export default __webpack_public_path__ + "static/media/ppi-logo-white.1915fa23.svg";